export default {
  // 配置日期选择器的快捷选项与禁用日期
  disabledDate: time => {
    return time.getTime() > Date.now()
  },
  shortcuts: [{
    text: '最近半年',
    onClick (picker) {
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 180)
      picker.$emit('pick', [start, end])
    }
  }, {
    text: '最近一年',
    onClick (picker) {
      const end = new Date()
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 365)
      picker.$emit('pick', [start, end])
    }
  }]
}



// WEBPACK FOOTER //
// ./src/utils/dateShortCutOptions.js